<script>
import Layout from '@layouts/main'

import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

/**
 * Dashboard-1 Component
 */
export default {
  components: { Layout, Loading },
  data() {
    return {
      mostraForm: true,
      form: {
        frquencySelected: 'mensalmente',
      },
      accountFrequency: [
        { value: 'diariamente', text: 'Diariamente' },
        { value: 'semanalmente', text: 'Semanalmente' },
        { value: 'quinzenalmente', text: 'Quinzenalmente' },
        { value: 'mensalmente', text: 'Mensalmente' },
      ],
      banksAccounts: [
        {
          value: '001-0000-00000',
          text: 'Banco: 001 - Banco do Brasil, agencia: 0000-0, conta: 0000000-0',
        },
        {
          value: '033-0000-00000',
          text: 'Banco: 033 - Banco Santander, agencia: 0000-0, conta: 0000000-0',
        },
        {
          value: '237-0000-00000',
          text: 'Banco: 237 - Bradesco, agencia: 0000-0, conta: 0000000-0',
        },
        {
          value: '341-0000-00000',
          text: 'Banco: 341 - Itaú, agencia: 0000-0, conta: 0000000-0',
        },
      ],
      clients: ['Empresa 1', 'Empresa 2', 'Empresa 3', 'Empresa 4'],
      costCenter: [
        'Financeiro',
        'Recursos Humanos',
        'Tecnologia da Informação',
        'Contabilidade',
      ],
      contasApagar: [
        { id: 1, field1: 'Content', field2: 'Content', field3: 'Content' },
      ],
      contasAPagarField: [
        {
          key: 'id',
          label: 'ID',
          class: 'size-col-20',
        },
        ,
        {
          key: 'field1',
          label: 'Field1',
          class: 'size-col-20',
        },
        {
          key: 'field2',
          label: 'Field2',
          class: 'size-col-20',
        },
        {
          key: 'field3',
          label: 'Field3',
          class: 'size-col-20',
        },
        { key: 'actions', label: '', class: 'size-col-10' },
      ],

      clientesField: [
        {
          key: 'ncm',
          label: 'NCM',
          class: 'size-col-20',
        },
        ,
        {
          key: 'descricao',
          label: 'Descrição/Segmento',
          class: 'size-col-20',
        },
        {
          key: 'uf',
          label: 'UF destino',
          class: 'size-col-20',
        },
        {
          key: 'tributacao',
          label: 'Tributação aplicada',
          class: 'size-col-20',
        },
      ],

            tributacaoField: [
        {
          key: 'tributacaoSugerida',
          label: 'Tributação Sugerida',
          class: 'size-col-20',
        },
      ],
      currentPage: 1,
      perPage: 20,
      showModal: false,
    }
  },
  computed: {},

  watch: {},
  mounted() {},
  methods: {
    loading(a) {
      a = !this.isLoading ? true : false
      return a
    },
    cadastra() {
      //   if (this.produtoEdit) {
      //     this.produtoEdit = {}
      //   }
      if (this.mostraForm === true) {
        this.mostraForm = false
      } else {
        this.mostraForm = true
        this.listar()
      }
    },
    modalToView(id) {
      this.$bvModal.show('modal-to-view')
      this.idProduto = id
    },
    printWindow() {
      window.print()
    },
  },
}
</script>

<template>
  <Layout>
    <div class="bloco">
      <div class="cabecalho">
        <div class="row">
          <div class="col-md-11">
            <div class="titulo">Processamento de arquivos</div>
            <div class="subTitulo">
              Acompanhe o processamento dos seus arquivos.
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="borda"></div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-2">
          <b-form-group id="input-group-1" label="Produto" label-for="filter">
            <v-select class="style-select" label="nome"></v-select>
          </b-form-group>
        </div>

        <div class="col-md-2">
          <button class="btn btn-webreceita" @click.prevent="listar"
            >Filtrar</button
          >
        </div>
      </div>

      <div>
        <b-table
          striped
          hover
          responsive="sm"
          borderless
          bordered
          outlined
          small
          :items="contasApagar"
          :fields="contasAPagarField"
          :per-page="perPage"
        >
          <template v-slot:cell(actions)="row">
            <div class="btn-group mb-2">
              <button
                v-b-tooltip.hover
                title="Editar"
                type="button"
                class="btn btn-light"
                @click="modalToView(row.item)"
              >
                <i class="uil uil-eye"></i>
              </button>
            </div>
          </template>
          <template v-slot:cell(ativo)="row">{{
            row.item.ativo ? 'Sim' : 'Não'
          }}</template>
        </b-table>
        <b-pagination
          v-model="currentPage"
          size="md"
          :total-rows="rows"
          :per-page="perPage"
        ></b-pagination>
      </div>
    </div>
    <b-modal
      id="modal-to-view"
      size="xl"
      title="Detalhe"
      title-class="font-18"
      centered
      hide-footer
    >
      <div class="container p-4">
        <div class="row">
          <div class="col text-center">
            <h3 class="m-0 mb-4">Resumo da Nota fiscal</h3>
          </div>
        </div>
        <div class="row mb-5">
          <div class="col-6">
            <table class="w-100">
              <tr>
                <td>
                  <strong> Dados origem da operação </strong>
                </td>
                <td>(Estado de Origem)</td>
              </tr>
              <tr>
                <td>
                  <strong> Destino da operação </strong>
                </td>
                <td>(Estado de Destino)</td>
              </tr>
              <tr>
                <td>
                  <strong>
                    Regime tributário do emitente da Nota fiscal
                  </strong>
                </td>
              </tr>
              <tr>
                <td>Simples ou Regime normal</td>
              </tr>
            </table>
          </div>
          <div class="col-5">
            <table class="w-100">
              <tr>
                <td>
                  <strong> NCM </strong>
                </td>
              </tr>
              <tr>
                <td>
                  <strong> Descrição: </strong>
                </td>
              </tr>
              <tr>
                <td>
                  <strong> Tributação: </strong>
                </td>
                <td>PIS/COFINS, IPI e ICMS</td>
              </tr>
              <tr>
                <td>
                  <strong> CST </strong>
                </td>
                <td>PIS/COFINS, IPI e ICMS</td>
              </tr>
              <tr>
                <td>
                  <strong> Código de benefício </strong>
                </td>
                <td>(IPI e ICMS)</td>
              </tr>
            </table>
          </div>
        </div>

        <div class="row">
          <div class="col-8 p-0 text-center">
            <h5 class="m-0">Dados cliente</h5>
            <b-table hover :fields="clientesField">
              <thead>
                <tr>
                  <th>NCM</th>
                  <th>Descrição/Segmento</th>
                  <th>UF destino</th>
                  <th>tributação aplicada</th>
                </tr>
              </thead>
            </b-table>
          </div>
          <div class="col-4 text-center">
            <h5 class="m-0">Dados fisco</h5>
            <b-table hover :fields="tributacaoField">
              <thead>
                <th>Tributação Sugerida</th>
              </thead>
            </b-table>
          </div>
        </div>
      </div>
      <!-- <template v-slot:modal-footer>
        <b-button variant="danger" @click="printWindow()">Imprimir</b-button>
      </template> -->
    </b-modal>
    <loading
      :active.sync="isLoading"
      color="#008e75"
      :can-cancel="false"
    ></loading>
  </Layout>
</template>
<style lang="scss">
.bloco {
  margin-top: 30px;
  background-color: #fff;
  padding: 40px;
  border-radius: 0.25rem;
  .titulo {
    font-size: 25px;
    color: #008e75;
    margin-bottom: 10px;
    font-weight: bold;
  }
  .subtitulo {
    margin-bottom: 10px;
  }
  .borda {
    margin-top: 15px;
    margin-bottom: 15px;
    border-bottom: solid 1px #edeff4;
  }
  .formulario {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .btn-webreceita {
    margin-top: 30px;
    margin-bottom: 10px;
    background-color: #008e75;
    padding: 5px 30px;
    &.botaoTopo {
      float: right;
    }
  }
  .filterButton {
    // margin-top: 5px;
    // margin-bottom: 10px;
    background-color: #008e74c7;
    padding: 0 20px;
  }
  .cadastra {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
.table-modal {
  width: 100%;

  th,
  td,
  tr {
    border: 1px solid #000 !important;
  }
}
</style>